var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDd6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2827_26062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7193 8.18463V15.6321H7.08557C7.14839 14.9427 7.18429 14.267 7.27628 13.6004C7.5646 11.505 8.17264 9.50753 9.10377 7.61263C9.20025 7.4155 9.26868 7.24345 9.56148 7.32093C11.5314 7.84052 13.5395 8.08436 15.5712 8.15386C15.6116 8.155 15.6509 8.16982 15.7193 8.18349V8.18463Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7194 15.6321H17.1115V8.17897C17.5221 8.15048 17.9518 8.14707 18.3736 8.0844C19.989 7.84739 21.6023 7.59443 23.2143 7.3392C23.4017 7.30957 23.5442 7.25374 23.6608 7.48847C24.9263 10.034 25.6061 12.7311 25.7194 15.631V15.6321Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7305 17.053V24.4924C15.2156 24.5255 14.7007 24.5232 14.1958 24.5984C12.6499 24.8274 11.1085 25.0918 9.56374 25.3242C9.44258 25.3425 9.22943 25.2684 9.18119 25.1727C7.90004 22.6351 7.22918 19.9346 7.10577 17.053H15.7294H15.7305Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6047 25.2798C21.4014 24.9767 19.2756 24.6839 17.1115 24.3865V17.0496H25.7149C25.5983 19.9973 24.8859 22.7559 23.6047 25.2798Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7792 15.6343H27.0724C26.9523 12.5635 26.2366 9.65566 24.8881 6.93351C26.1334 6.37632 27.3539 5.82939 28.6306 5.25739C31.1761 8.18121 32.5638 11.636 32.7803 15.6343H32.7792Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92808 6.95063C6.5942 9.64656 5.87398 12.5408 5.75394 15.6196H0C0.132378 14.6841 0.212029 13.7543 0.400499 12.8484C0.973761 10.0875 2.1876 7.63772 3.98928 5.48644C4.18112 5.25741 4.30788 5.2426 4.576 5.37477C5.66532 5.91373 6.7737 6.41281 7.92808 6.95063Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0437622 17.037H5.75395C5.88296 20.1033 6.59534 23.0123 7.93818 25.731C6.6963 26.2871 5.47461 26.834 4.19459 27.4072C1.65024 24.4913 0.2614 21.0365 0.0437622 17.037Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 27.2978C35.0913 27.5473 34.2477 27.7798 33.3424 28.0282C33.8057 29.7932 34.2634 31.5377 34.7334 33.33C33.91 33.5545 33.1079 33.7721 32.2721 34C31.7998 32.2179 31.3365 30.4723 30.8676 28.7016C29.9802 28.9409 29.1343 29.1676 28.2077 29.4172C28.7114 26.0626 29.2072 22.7628 29.7222 19.3387C31.8424 22.0267 33.9044 24.6395 36 27.2967V27.2978Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7227 0.0125122V6.78881C13.7875 6.73754 11.9005 6.50965 9.97882 6.02766C11.4832 3.59266 13.3668 1.62027 15.7227 0.0125122Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99002 26.6608C11.3082 26.2313 14.547 25.8142 15.7137 25.9168V32.6464C13.3724 31.0534 11.4854 29.0844 9.99002 26.6597V26.6608Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8206 5.98664C21.9467 6.36266 18.6013 6.82071 17.1205 6.774V0.0261841C19.4539 1.61457 21.3375 3.59038 22.8206 5.98664Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1227 25.886C19.0456 25.9145 20.9213 26.1663 22.8497 26.6335C21.3588 29.0685 19.4674 31.034 17.1227 32.6418V25.886Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1902 17.0393H28.7091C28.2211 20.2833 27.7365 23.5 27.2507 26.7269C26.4498 26.4056 25.6869 26.0991 24.9801 25.8153C25.4636 24.3842 26.0335 22.9815 26.4015 21.5265C26.7672 20.0771 26.9299 18.5753 27.1913 17.0404L27.1902 17.0393Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3073 0C12.3482 1.01981 11.352 2.01341 10.4354 3.07879C9.84981 3.75904 9.35844 4.52817 8.87156 5.28704C8.67748 5.59013 8.51369 5.64711 8.20182 5.51265C7.21684 5.08878 6.22289 4.68655 5.16162 4.24558C7.56573 1.99289 10.2604 0.600489 13.3073 0Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7725 0.0512695C22.5603 0.599344 25.255 1.99289 27.6737 4.25469C26.526 4.72073 25.458 5.15942 24.3844 5.57987C24.3081 5.6095 24.1399 5.53771 24.0826 5.46023C23.3714 4.49512 22.7073 3.49354 21.9624 2.55806C21.2253 1.63282 20.4086 0.77254 19.7736 0.0512695H19.7725Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3859 32.6008C11.592 32.7147 7.11139 30.4335 5.19415 28.4167C6.3519 27.9222 7.47038 27.4459 8.59895 26.9639C9.89693 29.1631 11.4698 31.0078 13.3859 32.5996V32.6008Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.519 32.6486C21.3588 31.0112 22.9271 29.1608 24.2229 26.9696C25.1069 27.3433 25.9808 27.7091 26.8491 28.0863C26.9187 28.117 27.0051 28.2321 26.9983 28.2982C26.9546 28.7107 26.9467 29.1027 26.5462 29.4149C24.5291 30.9907 22.2888 32.0595 19.8062 32.6099C19.7119 32.6304 19.6143 32.6349 19.519 32.6475V32.6486Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6313 17.0381H32.8229C32.6692 18.1491 32.5189 19.2327 32.3686 20.3163C32.3248 20.3243 32.2822 20.3334 32.2385 20.3414C31.3881 19.2646 30.5389 18.1879 29.6313 17.0381Z",
    fill: "#E66100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2827_26062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd6);
export default __webpack_public_path__ + "static/media/dd-6.de60a23c2921e2489d762cd6622eeb34.svg";
export { ForwardRef as ReactComponent };